<template>
  <div class="vx-row">
    <div class="vx-col flex-1" id="account-info-col-1">
      <template v-for="(fName,fId) in getCurrentDataStructureInChunk[0]">
        <vs-row :key="fId" class="p-2">
          <vs-col class="font-semibold" vs-type="flex" vs-w="6">{{fName[1].label }}</vs-col>

          <vs-col
            v-if="fName[1].type == 'aronSelect'"
            vs-type="flex"
            vs-w="5"
          >{{ decodeSelectValue(getMainInfo[fName[0]],fName[1].data) }}</vs-col>

          <vs-col
            v-else-if="fName[1].type == 'aronMultiSelect'"
            vs-type="flex"
            vs-w="5"
          >{{ decodeMultiSelectValue(getMainInfo[fName[0]]) }}</vs-col>

          <vs-col
            v-else-if="fName[1].type == 'aronCurrency'"
            vs-type="flex"
            vs-w="5"
          >{{formatCurrency(fName[1].currency, getMainInfo[fName[0]])}}</vs-col>

          <vs-col v-else vs-type="flex" vs-w="6">{{ getMainInfo[fName[0]] }}</vs-col>
        </vs-row>
      </template>
    </div>

    <div class="vx-col flex-1" id="account-info-col-2">
      <template v-for="(fName,fId) in getCurrentDataStructureInChunk[1]">
        <vs-row :key="fId" class="p-2">
          <vs-col class="font-semibold" vs-type="flex" vs-w="7">{{fName[1].label }}</vs-col>

          <vs-col
            v-if="fName[1].type == 'aronSelect'"
            vs-type="flex"
            vs-w="5"
          >{{ decodeSelectValue(getMainInfo[fName[0]],fName[1].data) }}</vs-col>

          <vs-col
            v-else-if="fName[1].type == 'aronMultiSelect'"
            vs-type="flex"
            vs-w="5"
          >{{ decodeMultiSelectValue(getMainInfo[fName[0]]) }}</vs-col>

          <vs-col
            v-else-if="fName[1].type == 'aronCurrency'"
            vs-type="flex"
            vs-w="5"
          >{{formatCurrency(fName[1].currency, getMainInfo[fName[0]])}}</vs-col>

          <vs-col v-else-if="fName[1].type == 'aronFile'" vs-type="flex" vs-w="6">
            <img :src="showFileOrImageHandler(getMainInfo[fName[0]])" />
          </vs-col>

          <vs-col v-else vs-type="flex" vs-w="5">{{ getMainInfo[fName[0]] }}</vs-col>
        </vs-row>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { helperMixin } from "../../../mixin/helperMixin";
import { dialogMixin } from "../../../mixin/dialogMixin";
import { axiosMixin } from "../../../mixin/axiosMixin";
 

import axios from "@/axios.js";
  
export default {
  mixins: [helperMixin, dialogMixin, axiosMixin],
  data() {
    return {
      showAlert: false,
      showRejectReason: false,
      rejectReasonMessage: "",
      reasonModel: "",
      payLoad: {},
      endPoint: "",
      rejectDialogTitle: "",
      successMessage: "",
      sucessEventName: "",
      successEventValue: ""
    };
  },
  computed: {
    ...mapGetters({
      getCurrentDataStructureInChunk: "profile/getCurrentDataStructureInChunk",
      getMainInfo: "profile/getCurrentMainInfo"
    }),
    settings() {
      this.showAlert = true; //we need to trigger this so that the alert will show

      return this.getMainInfoSettings(
        this.$route.params.subject,
        this.$route.params.key
      );
    },
    baseURl() {
      return axios.defaults.baseURL;
    }
  },
  mounted() {
    console.log("getMainInfo:", this.getMainInfo);
    console.log("currentStructure:", this.getCurrentDataStructureInChunk);
  },
  created() {},
  methods: {
    handleEmitEvent(eventName, eventValue) {
      this.$emit(eventName, { eventName: eventName, eventValue: eventValue });
    },
    handleSubmit(
      endPoint,
      title,
      message,
      payLoad,
      getReason,
      rejectReasonMessage,
      rejectDialogTitle,
      successMessage,
      sucessEventName,
      successEventValue
    ) {
      this.payLoad = payLoad;
      this.endPoint = endPoint;
      this.successMessage = successMessage;
      if (getReason) {
        this.showRejectReason = true;
        this.rejectReasonMessage = rejectReasonMessage;
        this.rejectDialogTitle = rejectDialogTitle;
      } else {
        this.confirmAlert(title, message).then(res => {
          this.submitNow();
        });
      }
    },
    validateReason() {
      if (this.reasonModel == "") {
        this.errorAlert("Required", "The Reason field is required");
        this.showRejectReason = true;
      } else {
        this.addToObject(this.payLoad, { rejectReason: this.reasonModel });
        this.submitNow();
      }
    },
    submitNow() {
      this.aronPost(this.endPoint, this.payLoad, "", "")
        .then(response => {
          if (response.data.status == "success") {
            this.normarAlert("Success", this.successMessage).then(res => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue
              });
            });
          } else {
            this.normarAlert(
              "Error",
              "Something Went wrong please try again later"
            ).then(res => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue
              });
            });
          }

          //go back
        })
        .catch(error => {
          console.log("error ActionContainer reason:", error);
        });
    },
    showFileOrImageHandler(source) {
      console.log("source:", source);
      var filename = this.getFileExtention(source);
      console.log("filename:", filename);
      if (filename == "pdf") {
        this.showPdf = true;
        this.thePdfSource = this.baseURl + "/storage/" + source;
      } else if (
        filename == "jpeg" ||
        filename == "jpg" ||
        filename == "png" ||
        filename == "gif"
      ) {
        this.showImage = true;
        return this.baseURl + "/storage/" + source;
      }
    },
    editData() {},
    formatCurrency(currency, value) {
      return this.displayCurrency(currency, value);
    },
    decodeSelectValue(value, options) {
      console.log("value:", value);
      console.log("options:", options);
      return this.decodeValueForSelect(options, value);
    },
    decodeMultiSelectValue(value) {
      return this.flattenJsonStringArray(value, "label");
    }
  }
};
</script> 